import { render, staticRenderFns } from "./CreateDrawer.vue?vue&type=template&id=27a8a9f1&"
import script from "./CreateDrawer.vue?vue&type=script&lang=js&"
export * from "./CreateDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CreateDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports